import { render, staticRenderFns } from "./CustomSvgCheckBox.vue?vue&type=template&id=3d61d9a8"
import script from "./CustomSvgCheckBox.vue?vue&type=script&lang=js"
export * from "./CustomSvgCheckBox.vue?vue&type=script&lang=js"
import style0 from "./CustomSvgCheckBox.vue?vue&type=style&index=0&id=3d61d9a8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports